import { gqlClient } from '@/api/graphql-client';
import estimateKeys from '@/api/queries/estimates/keyFactory';
import { graphql } from '@/gql';
import { useQuery } from '@tanstack/react-query';

graphql(`
  fragment RecommendedApplianceFields on RecommendedAppliance {
    heatingOutputKw
    appliance {
      id
      items {
        id
      }
      totalPrice {
        value
        currency {
          code
          exponent
        }
      }
      productSpec {
        id
        name
        category
        image {
          url
        }
        nominalOutputKw
        soundPowerDbA
        type
        domesticHotWaterLitres
      }
    }
  }
`);

const GetEstimateApplianceRecommendationsQuery = graphql(`
  query GetEstimateApplianceRecommendations($estimateId: ID!) {
    estimate(id: $estimateId) {
      id
      heatLossEstimate {
        recommendedHeatPumpAppliances {
          ...RecommendedApplianceFields
        }
        recommendedCylinderAppliances {
          ...RecommendedApplianceFields
        }
      }
    }
  }
`);

const useGetEstimateApplianceRecommendations = (estimateId?: string) => {
  const { data, ...rest } = useQuery({
    enabled: !!estimateId,
    queryKey: estimateKeys.applianceRecommendations(estimateId),
    queryFn: () =>
      gqlClient.request(GetEstimateApplianceRecommendationsQuery, {
        estimateId: estimateId!,
      }),
    meta: { errorMessage: 'Failed to load recommended Appliances' },
  });

  const heatLoss = data?.estimate?.heatLossEstimate;
  return {
    recommendedHeatPumps: heatLoss?.recommendedHeatPumpAppliances,
    recommendedCylinders: heatLoss?.recommendedCylinderAppliances,
    ...rest,
  };
};

export default useGetEstimateApplianceRecommendations;
